export default __webpack_public_path__ + "static/media/l5.dfcb873e.jpg";